import React from 'react';
export const PayContext = React.createContext({});